import api from "./api/client";

const vehicleService = {
  create(payload) {
    return api.post("/v1/vehicle", payload);
  },

  getAll(params = {}) {
    return api.get("/v1/vehicle", { params });
  },

  getById(id) {
    return api.get(`/v1/vehicle/${id}`);
  },

  update(id, payload) {
    return api.put(`/v1/vehicle/${id}`, payload);
  },

  delete(id) {
    return api.delete(`/v1/vehicle/${id}`);
  },
};

export default vehicleService;
